import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const emergingTechExercises: TopicExercises = {
  mcqs: [
    {
      id: "et1",
      difficulty: "easy",
      question: "Edge computing ka main faida kya hai?",
      options: ["Lower cost", "Reduced latency", "Increased complexity", "Enhanced security"],
      correctIndex: 1,
      explanation: "Edge computing data ko source ke paas process karta hai, is liye delay ya latency kam hoti hai.",
    },
    {
      id: "et2",
      difficulty: "easy",
      question: "Multiple organizations ke liye shared cloud model konsa hai?",
      options: ["Public Cloud", "Private Cloud", "Community Cloud", "Hybrid Cloud"],
      correctIndex: 2,
      explanation: "Community cloud multiple organizations ke liye shared environment hota hai.",
    },
    {
      id: "et3",
      difficulty: "medium",
      question: "Blockchain ka main advantage kya hai?",
      options: ["Centralized control", "Easy data change", "Transparency aur security", "Low computation"],
      correctIndex: 2,
      explanation: "Blockchain decentralization ki wajah se records transparent aur zyada secure hote hain.",
    },
    {
      id: "et4",
      difficulty: "easy",
      question: "Public + private cloud combine karne ko kya kehte hain?",
      options: ["Public", "Hybrid", "Community", "Multi-cloud"],
      correctIndex: 1,
      explanation: "Hybrid cloud me public aur private dono models ko combine kiya jata hai.",
    },
    {
      id: "et5",
      difficulty: "medium",
      question: "Blockchain me distributed ledger ka purpose kya hai?",
      options: ["Central authority", "Secure data sharing", "Fewer users", "Private storage"],
      correctIndex: 1,
      explanation: "Distributed ledger record ko shared aur secure banata hai taake har node updated copy rakh sake.",
    },
    {
      id: "et6",
      difficulty: "easy",
      topic: "cloud-models",
      anchor: "paas",
      question: "Platform provide karne wala cloud service konsa hai?",
      options: ["IaaS", "PaaS", "SaaS", "DaaS"],
      correctIndex: 1,
      explanation: "PaaS app banane walay ko ready platform deta hai jahan wo app bana aur chala sakta hai.",
    },
    {
      id: "et7",
      difficulty: "easy",
      topic: "cloud-models",
      anchor: "saas",
      question: "Email service ka example konsa cloud model hai?",
      options: ["IaaS", "PaaS", "SaaS", "Serverless"],
      correctIndex: 2,
      explanation: "Email service user ko complete software ke tor par milti hai, is liye yeh SaaS hai.",
    },
    {
      id: "et8",
      difficulty: "medium",
      question: "Blockchain 2.0 ka main feature kya hai?",
      options: ["Mining", "Smart contracts", "Graphics", "Speed"],
      correctIndex: 1,
      explanation: "Blockchain 2.0 ka focus smart contracts par hota hai jo rules ko automatically execute karte hain.",
    },
    {
      id: "et9",
      difficulty: "medium",
      question: "Serverless architecture ka main faida kya hai?",
      options: ["Cost saving", "Manual scaling", "Hardware control", "Server management"],
      correctIndex: 0,
      explanation: "Serverless me provider infrastructure handle karta hai, is liye cost aur management dono kam ho jate hain.",
    },
  ],
  short: [
    {
      id: "et-short-1",
      question: "P2P network kya hota hai?",
      answer: "Peer-to-peer network me nodes directly connect hote hain aur data share karte hain bina kisi central server ke.",
    },
    {
      id: "et-short-2",
      question: "Blockchain me immutability kya hoti hai?",
      answer: "Immutability ka matlab hai ke record add hone ke baad usay asani se change ya delete nahi kiya ja sakta.",
    },
    {
      id: "et-short-3",
      question: "Serverless ka kya faida hai?",
      answer: "Developer ko server manage nahi karna padta aur application demand ke mutabiq auto scale kar sakti hai.",
    },
  ],
  long: [
    {
      id: "et-long-1",
      question: "Cloud service models ko explain karo.",
      solution: "Cloud service models teen common forms me samjhay jate hain: IaaS, PaaS aur SaaS. In ka farq yeh hai ke user ko kitna control milta hai aur provider kitni responsibility leta hai.",
      steps: [
        "IaaS me virtual machines, storage aur network jaisi infrastructure milti hai.",
        "PaaS me platform ready milta hai jahan app banane wala asani se app bana sakta hai.",
        "SaaS me user ko direct software use karne ke liye milta hai, jaise Gmail ya Google Docs.",
      ],
    },
    {
      id: "et-long-2",
      question: "Blockchain ko simple words me explain karo.",
      solution: "Blockchain ek distributed ledger hai jahan records blocks ki form me store hote hain aur network ke multiple nodes ke paas un ki copies hoti hain. Is wajah se system decentralized, transparent aur comparatively secure hota hai.",
      steps: [
        "Data blocks me store hota hai.",
        "Har naya block pichlay block se linked hota hai.",
        "Ledger multiple nodes me shared hota hai.",
        "Isi wajah se unauthorized change mushkil ho jata hai.",
      ],
    },
    {
      id: "et-long-3",
      question: "Deployment models ko explain karo.",
      solution: "Cloud deployment models batate hain ke cloud environment kis tarah use ho raha hai. FSC level par public, private aur hybrid cloud sab se important hain.",
      steps: [
        "Public cloud sab ke liye available hota hai aur internet ke through access hota hai.",
        "Private cloud aik organization ke liye dedicated hota hai.",
        "Hybrid cloud me public aur private dono ko combine kiya jata hai.",
      ],
    },
  ],
};
